<div>
  <vo-header>
    <vo-header-navigation *ngIf="containsSideNav" (click)="toggleSideNav()"></vo-header-navigation>
    <a vo-anchor image voHeaderLogo href="{{ headerLogo.logoHref }}">
      <img [alt]="headerLogo.logoAlt" [src]="headerLogo.logoAsset | asset" />
    </a>
    <button
      *ngIf="containsLoginNav && isAuthenticated"
      vo-header-icon
      icon="faLock"
      title="Logout"
      (click)="toggleLoginNav()"></button>
    <button
      *ngIf="containsLoginNav && !isAuthenticated"
      vo-header-icon
      icon="faUser"
      title="Login"
      (click)="toggleLoginNav()"></button>
  </vo-header>
  <vo-header-decoration *ngIf="!heroType && variant !== headerVariant.primary" [variant]="variant" [containsHero]="containsHero"></vo-header-decoration>
  <div *ngIf="variant === headerVariant.primary" class="breadcrumb-position"></div>
  <div *ngIf="heroType" [class]="'hero ' + heroType"></div>
</div>

<vm-header-login-nav *ngIf="containsLoginNav" #loginNav></vm-header-login-nav>
<vm-header-side-nav *ngIf="containsSideNav" #sideNav></vm-header-side-nav>
